exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-42953610]:focus{outline:none}.lp-error-msg[data-v-42953610]{color:#e80000;font-size:.7rem}", ""]);

// exports
